<template>
  <section id="main-container">
    <v-container fluid>
      <v-layout flex>
        <v-flex xs12 style="max-width:1020px;margin:0 auto;">
          <div id="centered-content">
            <img
              height="160px"
              style="margin:0 auto; display:block; padding-bottom:40px; "
              slot="activator"
              src="../assets/login-cb-logo.svg"
            />

            <v-layout wrap row :style="$vuetify.breakpoint.mdAndUp && 'min-height:350px;'">
              <v-flex
                xs12
                md6
                class="login-box pa-4"
                style="border-top-right-radius: 5px;border-bottom-right-radius: 0px; border-bottom-left-radius: 0px;border-top-left-radius: 5px;'"
                :style="$vuetify.breakpoint.mdAndUp && 'border-top-right-radius: 0px;border-bottom-right-radius: 0px; border-bottom-left-radius: 5px;border-top-left-radius: 5px;'"
              >
                <v-flex style="display:table; height:100%; width:100%;" class="pa-4">
                  <div style="display:table-cell; vertical-align:middle;">
                    <h1 class="primary--text pb-3">Your custom domain</h1>
                    <v-form ref="form">
                      <v-text-field
                        box
                        label="Enter your custom domain name e.g. cocacola"
                        v-model="customDomain"
                        class="mb-0 pb-0"
                      ></v-text-field>
                      <p
                        style="margin-top:-5px; margin-bottom:16px "
                        class="d-block"
                      >https://{{ customDomain }}.caseblocks.com</p>
                      <router-link :to="{ name: 'Login'}">
                        <v-btn
                          block
                          class="ml-0 mb-2 mt-0"
                          color="secondary"
                          :style="$vuetify.breakpoint.mdAndUp && 'width:calc(50% - 10px); float:left; margin-right:20px; margin-bottom:0px !important'"
                        >Back</v-btn>
                      </router-link>
                      <v-btn
                        block
                        class="ml-0 mb-0 mt-0"
                        color="tertiary"
                        :style="$vuetify.breakpoint.mdAndUp && 'width:calc(50% - 10px)'"
                      >Continue</v-btn>
                    </v-form>
                  </div>
                </v-flex>
              </v-flex>
              <v-flex
                xs12
                md6
                class="promo-box pa-4"
                style="border-top-right-radius: 0px;border-bottom-right-radius: 5px; border-bottom-left-radius: 5px;border-top-left-radius: 0px;'"
                :style="$vuetify.breakpoint.mdAndUp && 'border-top-right-radius: 5px;border-bottom-right-radius: 5px; border-bottom-left-radius: 0px;border-top-left-radius: 0px;'"
              >
                <v-flex style="display:table; height:100%;width:100%;" class="pa-4">
                  <div style="display:table-cell; vertical-align:middle;">
                    <h2 class="pb-2" style="line-height:1.2em;">
                      Explore the latest new
                      features in Caseblocks
                    </h2>
                    <p>
                      We’ve been busy developing and expanding Caseblocks
                      core functionalilty to make it even better.
                    </p>
                    <v-btn class="ml-0 mt-1" color="secondary" outline>Explore</v-btn>
                  </div>
                </v-flex>
              </v-flex>
            </v-layout>
          </div>
        </v-flex>
      </v-layout>
    </v-container>
  </section>
</template>
<script>

export default {
  name: "CustomDomain",
  components: {},
  data: () => {
    return {
      customDomain: ""
    }
  }
}
</script>
